import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import BikeDetail from "./pages/BikeDetail";
import Service from "./pages/Service";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Products from "./pages/Products";
import LuisSalom from "./pages/LuisSalom";
import Dealership from "./pages/Dealership";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            setTimeout(() => {
                const el = document.getElementById(hash.slice(1));
                if (el) el.scrollIntoView({ behavior: "smooth" });
            }, 100);
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);
    return null;
}

function PublicLayout({ children }) {
    return (
        <>
            <Header />
            <main>{children}</main>
            <Footer />
            <WhatsAppButton />
        </>
    );
}

function App() {
    return (
        <div className="App">
            <ThemeProvider>
                <LanguageProvider>
                    <AuthProvider>
                    <BrowserRouter>
                        <ScrollToTop />
                        <Toaster
                            position="top-right"
                            theme="dark"
                            toastOptions={{
                                style: {
                                    background: "rgba(10,10,12,0.92)",
                                    border: "1px solid rgba(255,255,255,0.1)",
                                    color: "#f5f5f5",
                                    borderRadius: "2px",
                                },
                            }}
                        />
                        <Routes>
                            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
                            <Route path="/equipo" element={<PublicLayout><About /></PublicLayout>} />
                            <Route path="/historia" element={<PublicLayout><LuisSalom /></PublicLayout>} />
                            <Route path="/nosotros" element={<PublicLayout><Dealership /></PublicLayout>} />
                            <Route path="/motos" element={<PublicLayout><Catalog condition="new" /></PublicLayout>} />
                            <Route path="/ocasion" element={<PublicLayout><Catalog condition="used" /></PublicLayout>} />
                            <Route path="/motos/:id" element={<PublicLayout><BikeDetail /></PublicLayout>} />
                            <Route path="/productos" element={<PublicLayout><Products /></PublicLayout>} />
                            <Route path="/servicio" element={<PublicLayout><Service /></PublicLayout>} />
                            <Route path="/contacto" element={<PublicLayout><Contact /></PublicLayout>} />
                            <Route path="/admin/login" element={<PublicLayout><AdminLogin /></PublicLayout>} />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute>
                                        <PublicLayout>
                                            <AdminDashboard />
                                        </PublicLayout>
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                    </BrowserRouter>
                    </AuthProvider>
                </LanguageProvider>
            </ThemeProvider>
        </div>
    );
}

export default App;
